export { default } from './paymentMethods';
